module.exports = __webpack_public_path__ + "media/bootstrap-icons/speaker-fill-654503bc.svg";